<template>
  <div class="container" style="  width: 60%;
  margin: 0 auto;">
    <!-- 选择主体 -->
    <div class="select-container">
      <el-select
        v-model="selectedZtoken"
        placeholder="请选择主体"
        @change="handleChange"
        filterable
      >
        <el-option
          v-for="item in dataList"
          :key="item.id"
          :label="item.zhuti"
          :value="item.ztoken"
        />
      </el-select>
      <!-- 表单外部的提交按钮 -->
      <el-button
        type="primary"
        @click="handleSubmit"
        :disabled="isSubmitting"
      >
        开始新增资质
      </el-button>
      <el-dialog
        title="批量添加资质错误记录"
        :visible.sync="errorDialogVisible"
        width="30%">
        <div v-if="errorLogs.length">
          <p v-for="(error, index) in errorLogs" :key="index">
            {{ error }}
          </p>
        </div>
        <div v-else>
          <p>没有错误信息。</p>
        </div>
        <span slot="footer" class="dialog-footer">
        <el-button @click="errorDialogVisible = false">关闭</el-button>
      </span>
      </el-dialog>
    </div>
    <div class="container">
        <el-input
          type="textarea"
          v-model="idsText"
          placeholder="每行输入一个ID"
          :rows="5"
          @input="handleInput"
        />
    </div>
    <el-tabs v-model="AllactiveTab" >
      <el-tab-pane label="新增资质" name="新增资质">
        <!-- 表单模块 -->
        <el-form :model="form" ref="form" label-width="150px" class="form-section" :rules="rules">
          <!-- 行业选择 -->
          <el-form-item label="选择产品所属行业" prop="industry" required>
            <el-cascader v-model="form.industry" :options="options5" placeholder="请选择行业"  @change="handleIndustryChange" />
          </el-form-item>
          <el-form-item label="选择发布类型" prop="publishType" required>
            <el-radio-group v-model="form.publishType">
              <el-radio-button :label="3">快应用</el-radio-button>
              <el-radio-button :label="4">小程序</el-radio-button>
              <el-radio-button :label="1">网址</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <!-- 快应用字段 -->
          <template v-if="form.publishType === 3">
            <el-form-item label="快应用RPK包名" prop="quickAppPackageName" required>
              <el-input v-model="form.quickAppPackageName" placeholder="请输入快应用RPK包名" />
            </el-form-item>
            <el-form-item label="投放产品描述" prop="quickAppProductDescription" required>
              <el-input v-model="form.quickAppProductDescription" placeholder="请输入投放产品描述" />
            </el-form-item>
          </template>
          <!-- 网址字段 -->
          <template v-if="form.publishType === 1">
            <el-form-item label="投放产品名称" prop="websiteProductName" required>
              <el-input v-model="form.websiteProductName" placeholder="请输入投放产品名称" />
            </el-form-item>
            <el-form-item label="投放产品描述" prop="websiteProductDescription" required>
              <el-input v-model="form.websiteProductDescription" placeholder="请输入投放产品描述" />
            </el-form-item>
            <el-form-item label="ICP备案号" prop="icpLicense" required>
              <el-input v-model="form.icpLicense" placeholder="请输入ICP备案号" />
            </el-form-item>
            <el-form-item label="ICP链接" prop="icpLink" required>
              <el-input v-model="form.icpLink" placeholder="请输入ICP链接" />
            </el-form-item>
          </template>
          <template v-if="form.publishType === 4">
            <el-form-item label="投放产品名称" prop="xcxProductName" required>
              <el-input v-model="form.xcxProductName" placeholder="请输入投放产品名称" />
            </el-form-item>
            <el-form-item label="投放产品描述" prop="xcxProductDescription" required>
              <el-input v-model="form.xcxProductDescription" placeholder="请输入投放产品描述" />
            </el-form-item>
          </template>
        </el-form>
        <!-- Tabs 模块 -->
        <div class="qualification-section">
          <span class="title">附属行业资质<span class="required">*</span></span>
          <p class="description">行业资质说明，仅支持PNG/JPG/JPEG格式，且小于20M的图片</p>
          <el-card  shadow="hover">
            <el-tabs v-model="activeTab" type="border-card">
              <!-- 必要资质 Tab -->
              <el-tab-pane label="必要资质" name="necessary">
                <div class="qualification-grid">
                  <div v-for="(qualification, index) in necessaryQualifications" :key="index" class="qualification-item">
                    <!-- 上传组件 -->
                    <el-upload
                      ref="upload"
                      class="upload-demo"
                      :file-list="qualification.fileList"
                      accept=".png,.jpg,.jpeg"
                      list-type="picture-card"
                      :on-change="file => handleFileChange(index, file)"
                      :auto-upload="false"
                      action="#"
                    >
                      <i class="el-icon-plus" v-if="qualification.fileList.length === 0"></i>
                    </el-upload>
                    <el-select v-model="qualification.qualificationId" style="width: 148px;margin-top: 10px;margin-left: 20px;" placeholder="请选择资质类型" class="rounded-select">
                      <el-option v-for="type in qualification.qualificationOptions" :key="type.qualificationId" :label="type.qualificationName" :value="type.qualificationId" />
                    </el-select>
                  </div>
                </div>
              </el-tab-pane>
              <!-- 补充资质 Tab -->
              <el-tab-pane label="补充资质" name="supplementary">
                <p>请先选择资质类型再上传，最多可上传 15 项，每项最多可上传 5 张图片</p>
                <div class="qualification-grid">
                  <div
                    v-for="(item, index) in supplementaryQualifications"
                    :key="index"
                    class="qualification-item"
                  >
                    <!-- 资质类型选择器，选择变化时更新 qualificationName -->
                    <el-select
                      v-model="item.type"
                      placeholder="请选择资质类型"
                      class="rounded-select"
                      @change="updateSupplementaryQualificationName(index)"
                      style="width: 148px; margin-bottom: 10px; margin-left: 20px;"
                    >
                      <el-option
                        v-for="type in supplementaryQualificationTypes"
                        :key="type.qualificationId"
                        :label="type.qualificationName"
                        :value="type.qualificationId"
                      />
                    </el-select>
                    <el-upload
                      ref="upload"
                      class="upload-demo"
                      :auto-upload="false"
                      :limit="10"
                      multiple
                      action="#"
                      :file-list="item.fileList"
                      accept=".png,.jpg,.jpeg"
                      list-type="picture-card"
                      :on-change="file => supHandleFileChange(index, file)"
                      :on-remove="file =>nchandleRemove(index, file,item.fileList)"
                    >
                      <!-- 只有在上传的文件数小于5时显示上传按钮 -->
                      <i class="el-icon-plus" v-if="item.fileList.length < 100"></i>
                    </el-upload>
                    <!-- 删除按钮 -->
                    <el-button
                      type="danger"
                      size="small"
                      style="margin-top: 10px; margin-left: 20px;"
                      @click="removeQualification(index)"
                    >
                      删除
                    </el-button>
                  </div>
                </div>
                <!-- 添加补充资质按钮 -->
                <el-button type="text" @click="addSupplementaryQualification">+ 添加补充资质类型</el-button>
              </el-tab-pane>
              <!-- 其他资质 Tab -->
              <el-tab-pane label="其他资质" name="other">
                <p>请先填写资质名称再上传，最多可上传 15 项，每项最多可上传 5 张图片</p>
                <div class="qualification-grid">
                  <div v-for="(item, index) in otherQualifications" :key="index" class="qualification-item">
                    <!-- 资质名称输入框 -->
                    <el-input
                      style="width: 148px; margin-bottom: 10px; margin-left: 20px;"
                      v-model="item.name"
                      placeholder="请输入资质名称"
                      class="rounded-input"
                    />
                    <!-- 上传组件 -->
                    <el-upload
                      ref="upload"
                      class="upload-demo"
                      :auto-upload="false"
                      :limit="10"
                      multiple
                      action="#"
                      :file-list="item.fileList"
                      accept=".png,.jpg,.jpeg"
                      list-type="picture-card"
                      :on-change="file => otherHandleFileChange(index, file)"
                      :on-remove="file => othandleRemove(file)"
                    >
                      <!-- 只有上传的文件数小于5时，显示上传按钮 -->
                      <i class="el-icon-plus" v-if="item.fileList.length < 5"></i>
                    </el-upload>
                    <el-button
                      type="danger"
                      size="small"
                      style="margin-top: 10px; margin-left: 20px;"
                      @click="removeOtherQualification(index)"
                    >
                      删除
                    </el-button>
                  </div>
                </div>
                <el-button type="text" @click="addOtherQualification">+ 添加其他资质类型</el-button>
              </el-tab-pane>
            </el-tabs>
          </el-card>
        </div>
      </el-tab-pane>
      <el-tab-pane label="查询删除资质" name="查询删除资质">
        <div>
          <!-- 查询表单 -->
          <el-form ref="form" :inline="true" label-width="120px" style="margin-bottom: 20px;">
            <el-button type="primary" @click="handleSearch">查询</el-button>
            <!-- 批量删除按钮 -->
            <el-button
              type="danger"
              :disabled="!selectedRows.length"
              @click="handleBatchDelete"
              style="margin-top: 20px;"
            >删除选中</el-button>
          </el-form>
          <!-- 二级行业筛选 -->
          <el-select
            v-model="selectedIndustry2"
            placeholder="选择二级行业"
            @change="filterByIndustry2"
            style="width: 200px; margin-bottom: 20px;"
          >
            <el-option
              v-for="industry in industry2Options"
              :key="industry.value"
              :label="industry.label"
              :value="industry.value"
            ></el-option>
          </el-select>
          <!-- 结果表格 -->
          <el-table :data="filteredTableData" border style="width: 100%" v-if="filteredTableData.length > 0"  @selection-change="onselectedRows">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="uid" label="UID" width="100"></el-table-column>
            <el-table-column prop="industry1Name" label="一级行业" width="120"></el-table-column>
            <el-table-column prop="industry2Name" label="二级行业" width="120"></el-table-column>
            <el-table-column label="操作" width="120">
              <template slot-scope="scope">
                <el-button type="danger" size="mini" @click="handleDelete([scope.row])">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
    </el-tabs>
    <div v-if="queryStatus.visible" class="status-box">
      <div class="current-task">
        <span class="icon">⌛</span>
        {{ queryStatus.text }}
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {

      errorLogs: [], // 用于存储错误信息
      errorDialogVisible: false, // 控制弹窗显示
      AllactiveTab: '新增资质', // 默认选中的标签页
      otherUploadedQualifications: [], // 保存上传后的“其他资质”信息
      supplementaryUploadedQualifications: [], // 最终保存的补充资质数据
      necessaryQualifications: [], // 存储每个组合体的上传文件和资质类型选择
      uploadedQualifications: [] ,// 存储最后生成的组合数据
      isSubmitting: false,  // 控制按钮的禁用状态
      necessaryFileList:[], //必要图片列表
      //账户id
      idsText: "", // 存储用户输入的ID文本
      idsList: [], // 存储每行ID形成的数组
      //------------
      selectedZtoken: null,//取到的主体token值
      dataList:[], //取到的主体token值
      form: {
        industry: [],
        publishType: 3, // 默认为 3 对应“快应用”
        quickAppPackageName: '',
        quickAppProductName: '',
        quickAppProductDescription: '',
        websiteProductName: '',
        websiteProductDescription: '',
        xcxProductName: '',
        xcxProductDescription: '',
        icpLicense: '',
        icpLink: '',
      },
      rules: {
        industry: [{ required: true, message: '请选择行业', trigger: 'change' }],
        publishType: [{ required: true, message: '请选择发布类型', trigger: 'change' }],
        quickAppPackageName: [{ required: true, message: '请输入RPK包名', trigger: 'blur' }],
        quickAppProductName: [{ required: true, message: '请输入产品名称', trigger: 'blur' }],
        quickAppProductDescription: [{ required: true, message: '请输入产品描述', trigger: 'blur' }],
        websiteProductName: [{ required: true, message: '请输入产品名称', trigger: 'blur' }],
        websiteProductDescription: [{ required: true, message: '请输入产品描述', trigger: 'blur' }],
        xcxProductName: [{ required: true, message: '请输入产品名称', trigger: 'blur' }],
        xcxProductDescription: [{ required: true, message: '请输入产品描述', trigger: 'blur' }],
        icpLicense: [{ required: true, message: '请输入ICP备案号', trigger: 'blur' }],
        icpLink: [{ required: true, message: '请输入ICP链接', trigger: 'blur' }],
      },
      options5:[
        {
          value: '2100024',
          label: '系统/工具',
          children: [
            {
            value: '2220195',
            label: '系统软件'
          }, {
            value: '2220196',
            label: '体育健康'
          }, {
            value: '2220200',
            label: '天气日历'
          },
            {
              value: '2220202',
              label: '日常工具'
            },
            {
              value: '2220201',
              label: '浏览器'
            },

            {
              value: '2220197',
              label: '美图摄影'
            },
          ]},
        {
          value: '2100023',
          label: '娱乐影视',
          children: [{
            value: '2220193',
            label: '小说平台'
          },{
            value: '2220187',
            label: '视频'
          }, {
            value: '2220192',
            label: '段子漫画'
          },
            {
              value: '2220189',
              label: '音乐音频'
            },
          ]},
        {
          value: '2100027',
          label: '招商加盟',
          children: [{
            value: '2220239',
            label: '生活服务加盟'
          },
          ]
        },
        {
          value: '2100020',
          label: '教育',
          children: [{
            value: '2220162',
            label: '素质教育'
          },{
            value: '2220161',
            label: '理财培训'
          },
            {
              value: '2220167',
              label: '职业培训'
            },

            {
              value: '2220165',
              label: '语言培训'
            },
          ]},
        {
          value: '2100029',
          label: '金融',
          children: [

            {
            value: '2220260',
            label: '保险'
          },

            {
              value: '2220259',
              label: '第三方支付平台'
            },

          ]},
        {
          value: '2100018',
          label: '电商',
          children: [

            {
            value: '2220145',
            label: '优惠券'
          },

            {
              value: '2220142',
              label: '综合电商平台'
            },
          ]},
        {
          value: '2100012',
          label: '医疗服务',
          children: [
        {
            value: '2220064',
            label: '医疗器械'
          },
            {
              value: '2220072',
              label: '保健用品'
            },
            {
              value: '2220063',
              label: '医疗科室'
            }
            ,
            {
              value: '2220070',
              label: '药品'
            }

          ]},
        {
          value: '2100013',
          label: '生活服务',
          children: [{
            value: '2220099',
            label: '综合生活服务'
          },]},
        {
          value: '2100019',
          label: '直营电商',
          children: [
            {
              value: '2220158',
              label: '物品收藏'
            },
            {
            value: '2220149',
            label: '日用百货'
          },
            {
              value: '2220155',
              label: '个护美妆'
            },
            {
              value: '2220154',
              label: '其他'
            },
            {
              value: '2220159',
              label: '医药保健'
            },
            {
              value: '2220157',
              label: '零食饮料'
            },
            {
              value: '2220147',
              label: '服饰鞋包'
            },
          ]
        },
        {
          value: '2100009',
          label: '出版经营',
          children: [{
            value: '2220037',
            label: '出版物'
          }]},
        {
          value: '2100011',
          label: '食品',
          children: [{
            value: '2220045',
            label: '包装食品饮料'
          },{
            value: '2220046',
            label: '散装食品'
          }, {
            value: '2220062',
            label: '保健食品'
          },
            {
              value: '2220048',
              label: '酒品'
            },
          ]},
        {
          value: '2100016',
          label: '文玩收藏',
          children: [
            {
              value: '2220125',
              label: '集邮'
            },
            {
              value: '2220126',
              label: '纪念张'
            },
            {
              value: '2220127',
              label: '纪念币'
            },
            {
              value: '2220128',
              label: '退市人民币'
            },
            {
              value: '2220129',
              label: '手工制工艺品'
            },
            {
              value: '2220130',
              label: '特殊材质饰品'
            },
            {
              value: '2220131',
              label: '纪念钞'
            },
            {
              value: '2220132',
              label: '纪念章'
            },
            {
              value: '2220133',
              label: '文物经营'
            },
            {
              value: '2220134',
              label: '文物拍卖'
            },
            {
              value: '2220135',
              label: '文物复制品销售'
            },
            {
              value: '2220136',
              label: '文物商店'
            },
            {
              value: '2220137',
              label: '普通拍卖'
            },
            {
              value: '2220138',
              label: '司法拍卖平台'
            },

          ]},
        {
          value: '2100021',
          label: '旅游住宿',
          children: [
            {
              value: '2220169',
              label: '旅行社'
            },
            {
              value: '2220170',
              label: '代订服务'
            },
            {
              value: '2220171',
              label: '旅游景点'
            },
            {
              value: '2220172',
              label: '旅游平台'
            },
            {
              value: '2220173',
              label: '航空/游轮旅行'
            },
            {
              value: '2220174',
              label: '酒店住宿'
            },
            {
              value: '2220175',
              label: '农家乐、渔家乐'
            },
            {
              value: '2220176',
              label: '事业单位宣传'
            },
            {
              value: '2220177',
              label: '个人游记'
            },
            {
              value: '2220178',
              label: '旅游局'
            },

          ]},
      ],
      activeTab: 'necessary',
      necessaryQualificationType: null,
      qualificationTypes: [
        { availableStatus: 'type1',qualificationId:'', qualificationName: '测试类型1' },

      ],
      supplementaryQualificationTypes: [
      ],
      necessaryQualificationList: [],
      supplementaryQualifications: [],
      otherQualifications: [],
      necessaryImgList: [],
      supplementaryImgList:[],
      otherplementaryImgList:[],
      filteredTableData: [],
      selectedRows: [],
      selectedIndustry2: null, // 二级行业筛选的值
      industry2Options: [], // 二级行业下拉框选项
      queryStatus: {
        visible: false,      // 是否显示提示
        current: 0,         // 已处理户数
        total: 0,           // 总户数
        percent: '0%',      // 完成百分比
        uids: [],           // 当前正在查询的4个户号
        text: '',           // 完整提示文本
        progress: ''        // 进度文本 (例如 "5/20")
      }
    };
  },
  created() {
    this.fetchDataList()
  },
  methods: {
    othandleRemove(file) {
      const item = this.otherQualifications.find(item => item.fileList.includes(file));
      if (item) {
        const fileList = item.fileList;
        const fileIndex = fileList.findIndex(f => f.name === file.name);
        if (fileIndex !== -1) {
          fileList.splice(fileIndex, 1);
          this.$nextTick(() => {
            console.log('文件已从 fileList 中移除');
          });
        }
      }
    },
    // 处理文件删除
    nchandleRemove(index, file,fileList) {
      const fileIndex = fileList.findIndex(f => f.name === file.name);
      if (fileIndex !== -1) {
        fileList.splice(fileIndex, 1);
      }
    },
    onselectedRows(rows) {
      // selectedRows 是选中的行数据
      this.selectedRows = rows;
      console.log("Selected Rows:", rows);
    },
    async handleSearch() {
      this.tableData = [];
      this.filteredTableData = [];
      this.clearQueryStatus()
      const chunkSize = 4;
      const totalUsers = this.idsList.length; // 总户数
      let processedCount = 0; // 已处理户数计数器
      for (let i = 0; i < totalUsers; i += chunkSize) {
        const chunk = this.idsList.slice(i, i + chunkSize);
        processedCount = Math.min(i + chunkSize, totalUsers); // 准确计算已处理数
        // 更新进度显示
        this.showQueryStatus(chunk)   // 传入当前4个户号
        try {
          const promises = chunk.map(uid => this.fetchData(uid));
          const results = await Promise.all(promises);
          this.tableData.push(...results.flat());
        } finally {
          if (i + chunkSize < totalUsers) {
            await new Promise(resolve => setTimeout(resolve, 1000));
          }
        }
      }
      this.filteredTableData = [...this.tableData];
      this.showQueryStatus([]) // 清空当前查询户号显示
      this.clearQueryStatus();
      this.generateIndustry2Options();
    },
    showQueryStatus(currentChunk) {
      // 计算进度
      const current = Math.min(this.queryStatus.current + currentChunk.length, this.queryStatus.total)
      const percent = (current / this.queryStatus.total * 100).toFixed(1) + '%'
      // 更新状态
      this.queryStatus = {
        visible: true,
        current: current,
        total: this.queryStatus.total,
        percent: percent,
        uids: currentChunk,
        text: `正在查询户号：${currentChunk.join(', ')}`,
        progress: `${current}/${this.queryStatus.total} (${percent})`
      }
    },
    // 重置状态的方法
    clearQueryStatus() {
      this.queryStatus = {
        visible: false,
        current: 0,
        total: 0,
        percent: '0%',
        uids: [],
        text: '',
        progress: ''
      }
    },
    // 发送请求获取数据
    async fetchData(uid) {
      const timestamp = parseInt(new Date().getTime()) + '';
      const nonce = Math.round(Math.random() * 100000000000);
      const url = `api/openapi/v1/advertise/qualification/list?access_token=${this.selectedZtoken}&timestamp=${timestamp}&nonce=${nonce}&advertiser_id=${uid}`;
      const response = await axios.post(url, {});
      if (response.data.code === 0 && response.data.data) {
        return response.data.data.map(item => ({
          uid,
          industry1Name: this.getIndustryName(item.industry1, 1),
          industry2Name: this.getIndustryName(item.industry2, 2),
          industry2: item.industry2,
          advertiseQualificationList: item.advertiseQualificationList,
          selectedQualification: [], // 保存选择的资质
        }));
      }
      return [];
    },
    getIndustryName(id, level) {
      const levelData = level === 1 ? this.options5 : this.options5.flatMap(opt => opt.children);
      const match = levelData.find(opt => opt.value === String(id));
      return match ? match.label : "未知";
    },
    generateIndustry2Options() {
      // 强制将 industry2 转换为字符串，以便与 options5 中的 value 匹配
      const uniqueIndustry2 = new Set(this.tableData.map(item => String(item.industry2)));
      // 从 options5 中匹配 industry2 值，并生成筛选选项
      this.industry2Options = Array.from(uniqueIndustry2).map(industry2Id => {
        const industry = this.options5.flatMap(opt => opt.children).find(opt => String(opt.value) === industry2Id);
        return industry ? { value: industry.value, label: industry.label } : null;
      }).filter(Boolean);
    },
      // 根据选择的二级行业筛选数据
    filterByIndustry2() {
      if (this.selectedIndustry2) {
        this.filteredTableData = this.tableData.filter(item => {
          // 强制将两个值转换为相同类型进行比较
          return String(item.industry2) === String(this.selectedIndustry2);
        });
        console.log("Filtered Table Data:", this.filteredTableData);
      } else {
        this.filteredTableData = this.tableData; // 未选择筛选条件时，显示全部数据
      }
    },
    // 处理单条删除操作
    async handleDelete(rows) {
      console.log(rows);
      // 提取每个对象中 advertiseQualificationList 的 advertiseQualificationId 并形成新数组
      const ids = rows.flatMap(row => row.advertiseQualificationList.map(item => item.advertiseQualificationId));
      console.log(ids); // 打印生成的新数组
      await this.deleteQualifications(ids,rows[0].uid);
      await this.handleSearch()
    },
    async handleBatchDelete() {
      // 添加延时方法
      const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));
      try {
        for (const [index, item] of this.selectedRows.entries()) {
          try {
            const ids = item.advertiseQualificationList.map(q => q.advertiseQualificationId);
            const response = await this.deleteQualifications(ids, item.uid);
            this.$message({
              type: 'success',
              message: `正在删除第 ${index + 1}/${this.selectedRows.length} 项 [成功]`,
              duration: 1500,
              showClose: true
            });
            await sleep(700); // 实际间隔 = 700ms + 消息显示1500ms ≈ 2秒
          } catch (error) {
            console.error("删除失败:", error);
            this.$message({
              type: 'error',
              message: `第 ${index + 1} 项删除失败: ${error.message}`,
              duration: 3000
            });
          }
        }
        this.$message.success({
          message: `批量删除完成，共处理 ${this.selectedRows.length} 项`,
          duration: 2000
        });
      } catch (error) {
        this.$message.error('批量删除过程中发生错误');
      }
    },
    // 删除请求
    async deleteQualifications(ids, uid) {
      const timestamp = parseInt(new Date().getTime()) + '';
      const nonce = Math.round(Math.random() * 100000000000);
      const url = `api/openapi/v1/advertise/qualification/batchDelete?access_token=${this.selectedZtoken}&advertiser_id=${uid}&timestamp=${timestamp}&nonce=${nonce}`;
      console.log("发送删除请求...");
      const response = await axios.post(url, { advertiseQualificationIdList: ids });
      // 强制延迟，模拟慢速接口
      await new Promise(resolve => setTimeout(resolve, 1000));
      console.log("删除请求完成。");
    },
    //选项验证
    handleSubmit() {
      this.MJCreate();
    },
    async  batchAddQualifications(advertiseQualificationAddList, accessToken, advertiserId) {
      try {
        // 动态生成时间戳和随机数
        const timestamp = parseInt(new Date().getTime()) + '';
        const nonce = Math.round(Math.random() * 100000000000);
        // 设置请求 URL
        const url = `api/openapi/v1/advertise/qualification/batchAdd?access_token=${accessToken}&timestamp=${timestamp}&nonce=${nonce}&advertiser_id=${advertiserId}`;
        // 发起 POST 请求
        const response = await axios.post(url, { advertiseQualificationAddList });
        // 处理响应
        if (response.data.code === 0) {
          console.log("请求成功:", response.data);
          return response.data;
        } else {
          this.$message({ message: '账户'+ advertiserId + '批量上传失败', type: 'error' });
          this.errorLogs.push('账户'+ advertiserId + '批量上传失败'); // 记录错误信息
          if (this.errorLogs.length > 0) {
            this.errorDialogVisible = true;
          }
          console.error("请求失败:", response.data.message);
          return null;
        }
      } catch (error) {
        console.error("请求出错:", error);
        return null;
      }
    },
    // 资质创建
    async  MJCreate(){
      if (this.idsList.length<= 0){
        this.$message({ message: '请先输入账户id', type: 'error' });
      }
      // 根据id多户创建
      for (let i = 0; i < this.idsList.length; i++) {
        if (this.form.publishType==1){
          // 按顺序执行必要资质、补充资质和其他资质上传操作
          await this.saveUploadedQualifications(this.idsList[i]);
          await this.saveSupplementaryQualifications(this.idsList[i]);
          await this.saveOtherQualifications(this.idsList[i]);
          // 合并所有上传的资质信息
          const qualificationList = [
            ...this.uploadedQualifications,
            ...this.supplementaryUploadedQualifications,
            ...this.otherUploadedQualifications
          ];
          console.log("合并后的资质信息:", qualificationList);
          // 构建广告资质列表
          const advertiseQualificationAddList = [
            {
              industry1: this.form.industry[0], // 一级行业ID
              industry2: this.form.industry[1], // 二级行业ID
              productType: this.form.publishType, // 产品类型
              productName: this.form.websiteProductName, // 产品名称
              productDescription: this.form.websiteProductDescription, // 产品描述
              icpCaseNumber: this.form.icpLicense, // ICP备案号（可选）
              icpDomainName: this.form.icpLink, // ICP域名
              qualificationList: qualificationList
            }
          ];
          console.log("创建的广告资质列表:", advertiseQualificationAddList);
          await this.batchAddQualifications(advertiseQualificationAddList, this.selectedZtoken, this.idsList[i])
            .then(data => {
              if (data) {
                this.$message.success(this.idsList[i]+"所有必要资质信息已成功上传！");
                console.log( this.idsList[i]+"批量添加资质成功:", data);
              }
            })
            .catch(error => {
              this.$message.error(this.idsList[i]+"所有必要资质信息上传失败！")
            });
          this.uploadedQualifications = [];
          this.supplementaryUploadedQualifications = [];
          this.otherUploadedQualifications = [];
        }else{
          // 快应用
          // 按顺序执行必要资质、补充资质和其他资质上传操作
          await this.saveUploadedQualifications(this.idsList[i]);
          await this.saveSupplementaryQualifications(this.idsList[i]);
          await this.saveOtherQualifications(this.idsList[i]);

          // 合并所有上传的资质信息
          const qualificationList = [
            ...this.uploadedQualifications,
            ...this.supplementaryUploadedQualifications,
            ...this.otherUploadedQualifications
          ];
          console.log("合并后的资质信息:", qualificationList);

          // 构建广告资质列表
          const advertiseQualificationAddList = [
            {
              industry1: this.form.industry[0], // 一级行业ID
              industry2: this.form.industry[1], // 二级行业ID
              productType: this.form.publishType, // 产品类型
              productName: this.form.publishType===3?this.form.quickAppPackageName:this.form.xcxProductName, // 包
              productDescription: this.form.publishType===3?this.form.quickAppProductDescription:this.form.xcxProductDescription, // 快应用产品描述
              qualificationList: qualificationList
            }
          ];

          console.log("创建的广告资质列表:", advertiseQualificationAddList);

          await this.batchAddQualifications(advertiseQualificationAddList, this.selectedZtoken, this.idsList[i])
            .then(data => {
              if (data) {
                this.$message.success(this.idsList[i]+"所有必要资质信息已成功上传！");
                console.log(this.idsList[i]+"批量添加资质成功:", data);
              }
            })
            .catch(error => {
              this.$message.error(this.idsList[i]+"所有必要资质信息上传失败！");

            });
          // 清空每个列表，以便下一轮循环使用
          this.uploadedQualifications = [];
          this.supplementaryUploadedQualifications = [];
          this.otherUploadedQualifications = [];
        }
      }
    },
    // 保存用户选择的资质类型和上传的文件 URL
    // 统一保存上传的资质信息
    async saveUploadedQualifications(id) {
      try {
        // 遍历 necessaryQualifications 数组，依次上传每张图片
        for (let qualification of this.necessaryQualifications) {
          if (qualification.fileList.length > 0) {
            // 获取文件对象并创建 FormData
            const formData = new FormData();
            formData.append('file', qualification.fileList[0].raw); // 假设 file.raw 是文件对象
            // 调用 zzImgUpload 上传并获取返回的文件 URL
            qualification.qualificationFileUrl = await this.zzImgUpload(formData, id);
          }
        }
        // 将上传后的数据格式化为最终保存的格式
        this.uploadedQualifications = this.necessaryQualifications.map(item => ({
          qualificationType: item.qualificationType, // 保存 qualificationType
          qualificationId: item.qualificationId, // 用户选择的资质类型 ID
          qualificationFileUrl: item.qualificationFileUrl, // 上传的文件 URL
          qualificationName: item.qualificationName // 默认 qualificationName 为空
        }));
        console.log("必要资质信息:", this.uploadedQualifications);
        this.$message.success("所有必要资质信息已成功上传！");
      } catch (error) {
        console.error("必要资质上传失败:", error);
        this.$message.error("上传资质信息失败："+error);
      }
    },
    // 必要
    // 处理上传文件变更事件，仅将文件添加到 fileList，不进行上传
    handleFileChange(index, file) {
      this.necessaryQualifications[index].fileList = [file]; // 仅存储文件，不立即上传
    },
    removeQualification(index){
      this.supplementaryQualifications.splice(index, 1);
    },
// 处理文件变更，仅暂存文件，不立即上传
    supHandleFileChange(index, file) {
      if (!this.supplementaryQualifications[index].fileList) {
        this.$set(this.supplementaryQualifications[index], 'fileList', []);
      }
      this.supplementaryQualifications[index].fileList.push(file); // 多图暂存
    },
    // 删除指定索引的其他资质
    removeOtherQualification(index) {
      this.otherQualifications.splice(index, 1);
    },
    // 处理文件变更，仅暂存文件，不立即上传
    otherHandleFileChange(index, file) {
      if (!this.otherQualifications[index].fileList) {
        this.$set(this.otherQualifications[index], 'fileList', []);
      }
      this.otherQualifications[index].fileList.push(file); // 多图暂存
    },
    // 保存所有补充资质信息
    async saveSupplementaryQualifications(id) {
      try {
        // 遍历 supplementaryQualifications 数组，依次上传每张图片
        for (let item of this.supplementaryQualifications) {
          if (item.fileList.length > 0) {
            item.qualificationFileUrls = [];

            for (let file of item.fileList) {
              // 获取文件对象并创建 FormData
              const formData = new FormData();
              formData.append('file', file.raw); // 假设 file.raw 是文件对象

              // 调用上传接口并获取返回的文件 URL
              const url = await this.zzImgUpload(formData, id);
              item.qualificationFileUrls.push(url);
            }
            // 将所有文件 URL 连接成逗号分隔的字符串
            item.qualificationFileUrl = item.qualificationFileUrls.join(',');
          }
        }
        // 将上传后的数据格式化为最终保存的格式
        this.supplementaryUploadedQualifications = this.supplementaryQualifications.map(item => ({
          qualificationType: 1, // 补充资质的 qualificationType 固定为 1
          qualificationId: item.type, // 用户选择的资质类型 ID
          qualificationFileUrl: item.qualificationFileUrl || '', // 上传的文件 URL，多个图片用逗号分隔
          qualificationName: item.qualificationName // 选择的资质类型名称
        }));
        console.log("保存的补充资质信息:", this.supplementaryUploadedQualifications);
        this.$message.success("补充资质信息已成功上传！");
      } catch (error) {
        console.error("补充资质信息上传失败:", error);
        this.$message.error("上传补充资质信息失败："+error);
      }
    },
// 保存其他资质信息，上传多张图片
    async saveOtherQualifications(id) {
      try {
        // 遍历 otherQualifications 数组，依次上传每张图片
        for (let item of this.otherQualifications) {
          if (item.fileList.length > 0) {
            item.qualificationFileUrls = [];

            for (let file of item.fileList) {
              // 获取文件对象并创建 FormData
              const formData = new FormData();
              formData.append('file', file.raw); // 假设 file.raw 是文件对象

              // 调用上传接口并获取返回的文件 URL
              const url = await this.zzImgUpload(formData, id);
              item.qualificationFileUrls.push(url);
            }
            // 将所有文件 URL 连接成逗号分隔的字符串
            item.qualificationFileUrl = item.qualificationFileUrls.join(',');
          }
        }
        // 将上传后的数据格式化为最终保存的格式
        this.otherUploadedQualifications = this.otherQualifications.map(item => ({
          qualificationType: 2, // 其他资质的 qualificationType 固定为 2
          qualificationName: item.name, // 用户输入的资质名称
          qualificationFileUrl: item.qualificationFileUrl || '' // 上传的文件 URL，多个图片用逗号分隔
        }));
        console.log("保存的其他资质信息:", this.otherUploadedQualifications);
        this.$message.success("其他资质信息已成功上传！");
      } catch (error) {
        console.error("上传失败:", error);
        this.$message.error("其他资质信息上传失败："+error);
      }
    },
    // 必要资质图片上传接口
    async necessaryUploadFile(id) {
      if (this.necessaryFileList.length === 0) {
        this.$message.error('请先选择文件');
        return;
      }
      if (this.isUploading) {
        // this.$message.warning('文件正在上传，请稍候');
        return;
      }
      const formData = new FormData();
      const file = this.necessaryFileList[0].raw; // 获取文件
      formData.append('file', file);
      try {
        // 开始上传，设置上传标志
        this.isUploading = true;
        // 使用 await 等待上传完成，并将返回值添加到 necessaryImgList
        const filePath = await this.zzImgUpload(formData, this.idsList[0]);
        // 将上传后的文件路径添加到 necessaryImgList
        this.necessaryImgList.push(filePath);
      } catch (error) {
        console.error(error);
        this.$message.error('文件上传失败');
      } finally {
        // 上传完成，重置上传标志
        this.isUploading = false;
      }
    },
    // 文件上传方法
    async zzImgUpload(formData,id) {
      const time1 = Date.now().toString();
      const nonce = Math.round(Math.random() * 100000000000);
      const url = `api/openapi/v1/upload/file/image?access_token=${this.selectedZtoken}&timestamp=${time1}&nonce=${nonce}&advertiser_id=${id}`;
      try {
        // 发送上传请求
        const response = await axios.post(url, formData);
        return response.data.data.fileFullPath;  // 返回上传的文件路径
      } catch (error) {
        // 处理上传失败
        console.error('上传失败:', error);
        this.$message.error('文件上传失败');
        throw error; // 抛出错误以供外部处理
      }
    },
    // 取账户id
    handleInput() {
      // 根据每行生成 idsList 数组
      this.idsList = this.idsText
        .split('\n') // 按行分割
        .map(id => id.trim()) // 去除每行首尾空格
        .filter(id => id); // 过滤掉空行
    },
    //选择行业取出必要资质
    handleIndustryChange(value) {
      // 确保已选择二级行业（即 `value` 数组长度为 2）
      if (value.length === 2) {
        const secondaryIndustryId = value[1]; // 二级行业的值
        this.fetchQualificationData(secondaryIndustryId);
      }
    },
    async fetchQualificationData(secondaryIndustryId) {
      try {
        if (this.idsList.length <= 0) {
          this.$message.error('请先输入id再选择行业');
          return;
        }
        let time1 = parseInt(new Date().getTime()) + '';
        let nonce = Math.round(Math.random() * 100000000000);
        let list = [secondaryIndustryId];
        const response = await axios.post(
          `api/openapi/v1/advertise/qualification/dictionary/list?access_token=${this.selectedZtoken}&timestamp=${time1}&nonce=${nonce}&advertiser_id=${this.idsList[0]}`,
          { industry2List: list }
        );
        console.log("接口响应数据:", response.data) ;
        // 筛选 qualificationType 为 0 的项目，并生成 necessaryQualifications 数组
        this.necessaryQualifications = response.data.data[0].qualificationList
          .filter(item => item.qualificationType === 0)
          .map(item => ({
            fileList: [], // 用于暂存用户选择的文件
            qualificationType: item.qualificationType, // 保存 qualificationType
            qualificationName: "", // 默认 qualificationName 为空
            qualificationOptions: item.qualificationDictList, // 当前组合体的资质类型选项
            qualificationId: null, // 用户选择的资质类型 ID
            qualificationFileUrl: null // 上传完成后的文件 URL
          }));
        // 筛选 qualificationType 为 1 的数据并生成 supplementaryQualificationTypes 数组
        this.supplementaryQualificationTypes = response.data.data[0].qualificationList
          .filter(item => item.qualificationType === 1)
          .flatMap(item =>
            item.qualificationDictList.map(dict => ({
              qualificationId: dict.qualificationId,
              qualificationName: dict.qualificationName,
              qualificationType: item.qualificationType
            }))
          );
      } catch (error) {
        console.error("请求失败:", error);
        this.$message.error("获取资质数据失败，请稍后重试");
      }
    },
    // 添加新的补充资质组合体，最多 15 项
    addSupplementaryQualification() {
      if (this.supplementaryQualifications.length < 15) {
        this.supplementaryQualifications.push({ type: null, qualificationName: '', fileList: [] });
      } else {
        this.$message.error('补充资质最多只能添加 15 项');
      }
    },
    // 更新补充资质的 qualificationName，根据用户选择的资质类型
    updateSupplementaryQualificationName(index) {
      const selectedType = this.supplementaryQualificationTypes.find(
        type => type.qualificationId === this.supplementaryQualifications[index].type
      );
      this.supplementaryQualifications[index].qualificationName = selectedType ? selectedType.qualificationName : '';
    },
    // 添加新的“其他资质”组合体，最多 15 项
    addOtherQualification() {
      if (this.otherQualifications.length < 15) {
        this.otherQualifications.push({ name: '', fileList: [] });
      } else {
        this.$message.error('其他资质最多只能添加 15 项');
      }
    },
    // 取token
    fetchDataList() {
      try {
         axios.post('https://control.zjwec.cn/api/meijie/getAllData').then(response=>{
           this.dataList = response.data || []; // 使用 response.data.data 或 response.data
         })
      } catch (error) {
        console.error("获取数据失败:", error);
        this.$message.error("获取数据失败，请稍后重试");
      }
    },
    handleChange(value) {
      console.log('选中的 ztoken:', value); // 打印选中的 ztoken
      // 可以根据需要在这里处理选中的值
    }
  }
};
</script>
<style scoped>
.container {
  padding: 20px;
}
.select-container, .form-section, .qualification-section {
  margin-bottom: 20px;
}
.title {
  font-weight: bold;
  font-size: 16px;
}
.required {
  color: red;
}
.description {
  color: grey;
  font-size: 12px;
  margin-bottom: 10px;
}
.qualification-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.rounded-input, .rounded-select {
  border-radius: 10px;
  margin-right: 20px;
  flex: 1;
}
.upload-demo {
  flex: 1;
}
.el-upload__tip {
  font-size: 12px;
  color: grey;
}
.qualification-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 16px; /* 间距 */
}

.qualification-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 22%; /* 设置每个组合体的宽度，以便每行放 4 个 */
}
 .el-table .el-button {
   margin: 5px;
 }
.query-notice {
  padding: 12px;
  background: #f4f4f5;
  border-radius: 4px;
  margin: 10px 0;
  display: flex;
  align-items: center;
  color: #909399;
}

.loading-spinner {
  width: 14px;
  height: 14px;
  border: 2px solid #ccc;
  border-top-color: transparent;
  border-radius: 50%;
  margin-right: 8px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.progress {
  margin-left: 8px;
  color: #606266;
}
.status-box {
  padding: 12px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  margin: 10px 0;
}

.current-task {
  color: #606266;
  margin-bottom: 8px;
}

.progress {
  height: 24px;
  background: #f5f7fa;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
}

.bar {
  height: 100%;
  background: #409eff;
  transition: width 0.3s ease;
}

.text {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  color: white;
  text-shadow: 0 1px 2px rgba(0,0,0,0.3);
}
</style>



// WEBPACK FOOTER //
// src/components/meijiezz.vue